import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  helpContentText: {
    defaultMessage:
      "To get started, you'll import your products and their stock counts using a single CSV upload. <file>Download our sample CSV file</file> or <helpLink>learn more about importing a CSV.</helpLink>",
    id: 'wehrjT',
    description: 'Instructional text explaining how to import products with links to sample file and documentation',
  },
  uploadFile: {
    id: 'TiRrbx',
    defaultMessage: 'Import your inventory counts.',
    description: 'Title displayed at the top of the initial import step',
  },
  uploadFileDescription: {
    defaultMessage: 'Import your products and stock counts by uploading a csv file or excel file. <link>Learn more</link>',
    id: 'C+t6DL',
    description: 'Title displayed at the top of the initial import step',
  },
  selectInventoryWarehouse: {
    id: 'b9s4G+',
    defaultMessage: 'Select Inventory Warehouse',
    description: 'Default text shown in the warehouse selection dropdown when no warehouse is selected',
  },
  selectInventoryWarehouseHeader: {
    id: '/SEmK5',
    defaultMessage: 'Select warehouse to apply import to',
    description: 'Label text displayed above the warehouse selection dropdown',
  },
  addAWarehouse: {
    id: '6YFiYm',
    defaultMessage: 'Add an Inventory Warehouse',
    description: 'Text for the button to add a new inventory warehouse',
  },
  addWarehouseDescription: {
    id: '2PvKWB',
    defaultMessage: 'Create a warehouse to manage inventory from aisle to bin',
    description: 'Success message shown when a new inventory warehouse is added',
  },
  addWarehouse: {
    id: 'xi47FV',
    defaultMessage: 'Add inventory warehouse',
    description: 'Text for the button to add a new inventory warehouse',
  },
  recommendedBadge: {
    id: '07+KRB',
    defaultMessage: 'Recommended',
    description: 'Badge text indicating this is the recommended option',
  },
  uploadTitle: {
    id: '4u5BJn',
    defaultMessage: 'Upload Your Inventory',
    description: 'Title for the upload section',
  },
  downloadSampleText: {
    id: 'ca/Qz1',
    defaultMessage: 'Start by <link>downloading our sample CSV file</link>',
    description: 'Text before the download sample link',
  },
  downloadSample: {
    id: 'SD/CwB',
    defaultMessage: 'Downloading our sample CSV file',
    description: 'Link text for downloading sample CSV',
  },
  reviewFieldsText: {
    id: 'byxpXT',
    defaultMessage: 'Review the required, and recommended fields below helping you to get the most out of your inventory',
    description: 'Text explaining field requirements',
  },
  viewAll: {
    id: 'Gnj+Pu',
    defaultMessage: 'View all',
    description: 'Link text to view all fields',
  },
  selectFileText: {
    id: '3baz/H',
    defaultMessage: 'Select your file, or drag and drop to begin import',
    description: 'Text for file selection step',
  },
  skuFieldWithBullet: {
    id: 'eye+XF',
    defaultMessage: 'SKU •',
    description: 'SKU field label with bullet point',
  },
  stockCountFieldWithBullet: {
    id: '+ttCH7',
    defaultMessage: 'Stock Count •',
    description: 'Stock Count field label with bullet point',
  },
  warehouseLocationFieldWithBullet: {
    id: 'tZ/L94',
    defaultMessage: 'Warehouse Location •',
    description: 'Warehouse Location field label with bullet point',
  },
  requiredLabel: {
    id: 'idH8Y4',
    defaultMessage: 'Required',
    description: 'Label indicating a field is required',
  },
  warehouseLocationExample: {
    id: 'jdT4FU',
    defaultMessage: '(ie. row, bin, container)',
    description: 'Example text for warehouse location field',
  },
  createNew: {
    id: 's/Gg3b',
    defaultMessage: 'Create New',
    description: 'Link text to create a new inventory warehouse in the dropdown',
  },
});
